module.exports = __webpack_public_path__ + "static/media/joe-gardner-1.949b58f2.jpg";